import React, { useState } from "react";
import { useProducts } from "../context/ProductContext";
import ProductCard from "../components/ProductCard";
import AccountDetailsPopup from "../components/AccountDetailsPopup";

import { useLocation } from "react-router-dom";

const AllProductsPage = () => {
  const location = useLocation();
  const { products, categories } = useProducts();
  const [selectedCategory, setSelectedCategory] = useState(
    location.state?.category || "all",
  );
  const [showAccountPopup, setShowAccountPopup] = useState(false);

  const filteredProducts =
    selectedCategory === "all"
      ? products
      : products.filter((p) => p.category === selectedCategory);

  const handleWhatsAppClick = (product, variant, quantity) => {
    const accountDetails = localStorage.getItem("accountDetails");
    if (!accountDetails) {
      setShowAccountPopup(true);
      return;
    }

    const account = JSON.parse(accountDetails);
    const qty = quantity > 0 ? quantity : 1;
    const totalPrice = variant.offerPrice * qty;

    let message = `🛒 *NEW ORDER REQUEST*\n\n`;
    message += `📦 *Product Details:*\n`;
    message += `─────────────────\n`;
    message += `${product.name}\n`;
    message += `📏 Size: ${variant.size}\n`;
    message += `🔢 Quantity: ${qty}\n`;
    message += `💰 Price per unit: ₹${variant.offerPrice}\n`;
    message += `─────────────────\n`;
    message += `💵 *Total: ₹${totalPrice}*\n\n`;

    message += `📍 *Delivery Details:*\n`;
    message += `─────────────────\n`;
    message += `👤 Name: ${account.name || "N/A"}\n`;
    message += `📱 Mobile: ${account.mobile}\n`;
    message += `📧 Email: ${account.email || "N/A"}\n`;
    message += `🏠 Address:\n`;
    message += `   ${account.addressLine1}\n`;
    if (account.addressLine2) message += `   ${account.addressLine2}\n`;
    if (account.addressLine3) message += `   ${account.addressLine3}\n`;
    message += `   ${account.city}, ${account.state} - ${account.pincode}\n\n`;
    message += `*Additional shipping charges applicable.*\n`;

    const whatsappUrl = `https://wa.me/919840453354?text=${encodeURIComponent(
      message,
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20 md:pb-8">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            All Products
          </h1>
          <p className="text-gray-600">
            Showing {filteredProducts.length} products
          </p>
        </div>

        <div className="flex gap-4 md:gap-6">
          <div className="w-24 md:w-64 flex-shrink-0">
            <div className="bg-white rounded-lg shadow-md p-2 md:p-4 sticky top-20">
              <h3 className="text-sm md:text-lg font-bold text-gray-800 mb-2 md:mb-4 hidden md:block">
                Categories
              </h3>

              <div className="space-y-1 md:space-y-2">
                <button
                  onClick={() => setSelectedCategory("all")}
                  className={`w-full text-left px-2 md:px-4 py-2 md:py-3 rounded-lg transition-all flex flex-col md:flex-row items-center md:justify-between ${
                    selectedCategory === "all"
                      ? "bg-green-500 text-white font-semibold"
                      : "hover:bg-gray-100 text-gray-700"
                  }`}
                >
                  <span className="flex flex-col md:flex-row items-center gap-1 md:gap-2 text-center md:text-left">
                    <span className="text-xl">🛒</span>
                    <span className="text-xs md:text-base">All</span>
                  </span>
                  <span className="text-xs hidden md:inline">
                    ({products.length})
                  </span>
                </button>

                {categories.map((category) => {
                  const count = products.filter(
                    (p) => p.category === category.id,
                  ).length;
                  return (
                    <button
                      key={category.id}
                      onClick={() => setSelectedCategory(category.id)}
                      className={`w-full text-left px-2 md:px-4 py-2 md:py-3 rounded-lg transition-all flex flex-col md:flex-row items-center md:justify-between ${
                        selectedCategory === category.id
                          ? "bg-green-500 text-white font-semibold"
                          : "hover:bg-gray-100 text-gray-700"
                      }`}
                    >
                      <span className="flex flex-col md:flex-row items-center gap-1 md:gap-2 text-center md:text-left">
                        <span className="text-xl">{category.icon}</span>
                        <span className="text-xs md:text-base">
                          {category.name}
                        </span>
                      </span>
                      <span className="text-xs hidden md:inline">
                        ({count})
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="flex-1">
            {filteredProducts.length > 0 ? (
              <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                {filteredProducts.map((product) => (
                  <ProductCard
                    key={product.id}
                    product={product}
                    showCategory={false}
                    onWhatsAppClick={handleWhatsAppClick}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-16 bg-white rounded-lg shadow-md">
                <div className="text-6xl mb-4">📦</div>
                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                  No products found
                </h2>
                <p className="text-gray-600 mb-4">Try adjusting your filters</p>
                <button
                  onClick={() => setSelectedCategory("all")}
                  className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600 font-semibold"
                >
                  Clear Filters
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <AccountDetailsPopup
        isOpen={showAccountPopup}
        onClose={() => setShowAccountPopup(false)}
      />
    </div>
  );
};

export default AllProductsPage;
